angular
	.module 'App.Repository'

.factory 'AccessTokenRepository', ['BaseRepository', (BaseRepository) ->
		class AccessTokenRepository extends BaseRepository
			@resource = '/access_token'
			@isRestricted = true

		return new AccessTokenRepository
	]
